/**
 * @function
 * @description checks if the given payment method ID is Klarna payment category.
 * @param {string} paymentCategory the payment category ID
 * @returns {void}
 */
function isKlarnaPaymentCategory(paymentCategory) {
    var $klarnaPaymentCategories = document.querySelectorAll('.klarna-payment-categories');
    for (var i = 0; i < $klarnaPaymentCategories.length; i++) {
        var $klarnaPaymentCategory = $klarnaPaymentCategories[i];

        if (paymentCategory === $klarnaPaymentCategory.id) {
            return true;
        }
    }
    return false;
}

exports.init = function () {
    if (!($('.klarna-widget-payment-option').length > 0)) {
        return;
    }

    if (!window.isKlarnaWidgetEnabled) {
        $('.klarna-widget-payment-option').remove();
        return;
    }

    window.isKlarnaLoaded = false;
    var klarnaPaymentsUrls = window.KlarnaPaymentsUrls;
    var klarnaPaymentsObjects = window.KlarnaPaymentsObjects;
    var $klarnaPaymentCategories = document.querySelectorAll('.klarna-payment-categories');
    var $selectPaymentMethod = document.querySelectorAll('.payment-method-options .payment-method-radio:checked');
    var $continueBtn = document.getElementsByName('dwfrm_billing_save')[0];

    if (!klarnaPaymentsObjects || klarnaPaymentsObjects.clientTokens == null) {
        $('.klarna-widget-payment-option').remove();
        return;
    } else {
        $('.klarna-widget-payment-option').show();
    }

    window.klarnaAsyncCallback = function () {
        for (var i = 0; i < $klarnaPaymentCategories.length; i++) {
            var $klarnaPaymentCategory = $klarnaPaymentCategories[i];

            if (klarnaPaymentsObjects.clientTokens[$klarnaPaymentCategory.id] != null) {
                Klarna.Payments.init({
                    client_token: klarnaPaymentsObjects.clientTokens[$klarnaPaymentCategory.id]
                });

                var containerName = '#klarna_payments_' + $klarnaPaymentCategory.id + '_container';
                Klarna.Payments.load(
                    {
                        container: containerName,
                        payment_method_category: $klarnaPaymentCategory.id
                    },
                    function (res) {
                        if (res['show_form'] !== true) {
                            $klarnaPaymentCategory.closest('.klarna-widget-payment-option').remove();
                        }
                    }
                );
            } else {
                $klarnaPaymentCategory.closest('.klarna-widget-payment-option').remove();
            }
        }
        window.isKlarnaLoaded = true;
    };

    $('.paymentmethod-klarna, .paymentmethod-klarna_account').on('click', function () {
        if (!window.isKlarnaLoaded && 'klarnaAsyncCallback' in window) {
            window.klarnaAsyncCallback();
        }
    });

    if ($continueBtn) {
        $continueBtn.addEventListener('click', function (event) {
            var $selectedPaymentMethod = document.querySelectorAll(
                '.payment-method-options .payment-method-radio:checked'
            );

            if (
                $selectedPaymentMethod.length > 0 &&
                isKlarnaPaymentCategory($selectedPaymentMethod[0].dataset['klarna'])
            ) {
                event.preventDefault(); //prevent form submission until authorize call is done
                $continueBtn.disabled = true;

                Klarna.Payments.authorize(
                    {
                        payment_method_category: $selectedPaymentMethod[0].dataset['klarna'],
                        auto_finalize: false
                    },
                    function (res) {
                        if (res.approved) {
                            var xhr = new XMLHttpRequest();
                            xhr.open('GET', klarnaPaymentsUrls.saveAuth, true);
                            xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
                            xhr.setRequestHeader('X-Auth', res.authorization_token);
                            xhr.setRequestHeader('Finalize-Required', res.finalize_required);

                            xhr.onreadystatechange = function () {
                                if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                                    $selectedPaymentMethod.value = $selectedPaymentMethod[0].dataset['klarna'];
                                    //submit billing form when Klarna Payments authorization is successfully finished
                                    document.querySelectorAll('#dwfrm_billing')[0].submit();
                                }
                            };
                            xhr.send();
                        } else {
                            $continueBtn.disabled = false;
                            if (document.getElementsByClassName('loader').length > 0) {
                                document.getElementsByClassName('loader')[0].remove();
                            }
                        }
                    }
                );
            }
        });
    }
};
